import { Gauge } from 'lucide-react';
import type { NavItem } from './types';

/**
 * The «Folios» destination, with two children: «Stock» (the per (company, type)
 * policy and the lifecycle of the folio requests, A-06 of the frontend roadmap)
 * and «Consumo (RCOF)» (the consumption report, view 11 of §4.12).
 *
 * Both used to live apart — «Stock de folios» at the top level and the RCOF under
 * «Boletas y folios» — which is why the first one had to carry a long name to
 * avoid colliding with the second. Under one «Folios» parent the children no
 * longer need to repeat the noun (R8(i), C-2 resolved: go).
 *
 * `minimumPhase: 'in-certification'` and not `'operating'`: certifying needs
 * folios, so a shortage matters **before** the SII authorises the company —
 * which is exactly when nobody has the habit of looking at the folio email.
 *
 * It sits right after «Boletas» in the composition order, as the stock did.
 */
export const foliosNav: readonly NavItem[] = [
  {
    label: 'Folios',
    to: '/folios',
    icon: Gauge,
    group: 'operation',
    minimumPhase: 'in-certification',
    children: [
      { label: 'Stock', to: '/folios' },
      { label: 'Consumo (RCOF)', to: '/consumo-folios' },
    ],
  },
];
